import { Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { BRAND_ACCENT, BRAND_COLOR } from '@web/theme/theme';

/** Invoice glyph: a receipt with a zig-zag edge and a verified badge (same drawing as public/favicon.svg). */
export function LogoMark({ size = 32 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden focusable="false">
      <rect width="64" height="64" rx="14" fill={BRAND_COLOR} />
      <path d="M21 12h22a3 3 0 0 1 3 3v37l-4-3-4 3-4-3-4 3-4-3-4 3-4-3V15a3 3 0 0 1 3-3z" fill="#fff" />
      <rect x="23" y="19" width="18" height="3.2" rx="1.6" fill={BRAND_COLOR} />
      <rect x="23" y="26" width="12" height="3.2" rx="1.6" fill="#9dd6cf" />
      <rect x="23" y="33" width="16" height="3.2" rx="1.6" fill="#9dd6cf" />
      <circle cx="45" cy="45" r="10" fill={BRAND_ACCENT} stroke="#fff" strokeWidth="2.5" />
      <path d="M40.6 45.3l3 3 6-6.3" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Fatoorati mark + wordmark (Arabic first; the other language as a small line). */
export function Logo({ size = 32, withText = true }: { size?: number; withText?: boolean }) {
  const { t, i18n } = useTranslation();
  const en = i18n.language === 'en';
  return (
    <Group gap={8} wrap="nowrap" aria-label={t('common:app.name')} role="img">
      <LogoMark size={size} />
      {withText && (
        <Stack gap={0} style={{ lineHeight: 1 }}>
          <Text fw={800} size="lg" c="brand" style={{ whiteSpace: 'nowrap', lineHeight: 1.1 }}>
            {en ? 'Fatoorati' : 'فاتورتي'}
          </Text>
          <Text size="xs" c="dimmed" fw={600} style={{ whiteSpace: 'nowrap', lineHeight: 1.1, letterSpacing: en ? 0 : 0.3 }}>
            {en ? 'فاتورتي' : 'Fatoorati'}
          </Text>
        </Stack>
      )}
    </Group>
  );
}
